module.exports = __webpack_public_path__ + "media/images/emblems/Welschenrohr-blazon-7eae46a9e0fc14f7a6368b8d2412c247.svg";